import type { FC } from "react";
import Chip from "@mui/material/Chip";
import { Stack, Typography } from "@mui/material";
import type { TranslationKey } from "@privacy/translations";
import { useTranslation } from "@privacy/translations";

const EXAMPLE_KEYS: Array<TranslationKey> = [
  "Assistant.Welcome.ExampleCalls",
  "Assistant.Welcome.ExampleSurvey",
  "Assistant.Welcome.ExampleRecruitment",
];

export const AssistantExamples: FC<{ onPick: (text: string) => void }> = ({ onPick }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      component="section"
      aria-labelledby="assistant-examples-label"
      sx={{ gap: 1, alignItems: "center", flexWrap: "wrap" }}
    >
      <Typography
        id="assistant-examples-label"
        sx={{ color: "text.secondary", fontSize: theme => theme.typography.pxToRem(12), lineHeight: 1.5 }}
      >
        {t("Assistant.Welcome.ExamplesLabel")}
      </Typography>
      {EXAMPLE_KEYS.map(key => (
        <Chip
          key={key}
          label={t(key)}
          variant="outlined"
          size="small"
          clickable
          onClick={() => onPick(t(key))}
          sx={{
            "borderColor": theme => theme.palette.grey[400],
            "bgcolor": "background.paper",
            "fontSize": theme => theme.typography.pxToRem(12),
            "&:hover": { bgcolor: "action.hover" },
          }}
        />
      ))}
    </Stack>
  );
};
